import React from "react";
import "./ticketDetail.style";
import { Grid } from '@mui/material';
import { NOT_APPLICABLE } from '../../../constants/originalState';
import { DISPATCH_MODE } from "../constant";

export interface IPCRefreshDetailProps {
    infoTicket: any,
    configTracking: any,
    locale: any
};

const PCRefreshDetail = (props: IPCRefreshDetailProps) => {
    const { infoTicket, locale, configTracking } = props;
    const variableInfo = infoTicket.variables;

    return (
        <Grid container>
            <Grid item xs={12}>
                <p className="ttl-col-desc">{locale?.moreDetails}</p>
                <p className="value-info" id="lbl-pcrefresh-description">{!!infoTicket.description? infoTicket.description: NOT_APPLICABLE}</p>
            </Grid>
            <Grid item xs={6} className="pr-20">
                <p className="ttl-col-desc">{locale?.deviceBeingRefreshed}</p>
                <p className="value-info" id="lbl-pcrefresh-serial_number"><strong>{locale?.serialNumber}:</strong> {!!variableInfo?.asset?.serial_number? variableInfo?.asset?.serial_number: NOT_APPLICABLE}</p>
                <p className="value-info" id="lbl-pcrefresh-model"><strong>{locale?.modelName}:</strong> {!!variableInfo?.asset?.model? variableInfo?.asset?.model: NOT_APPLICABLE}</p>
            </Grid>
            <Grid item xs={6} className="pr-20">
                <p className="ttl-col-desc">{locale?.replacementDevice}</p>
                <p className="value-info" id="lbl-pcrefresh-replacementdevice"><strong>{locale?.modelName}:</strong> {infoTicket?.requestedModel?.name || NOT_APPLICABLE}</p>
            </Grid>
            <Grid item xs={6} className="pr-20">
                <p className="ttl-col-desc">{variableInfo?.json_storage?.new_device_dispatch_mode === DISPATCH_MODE.PICKUP_FROM_DEPOT ? locale?.pickUpAddress : locale?.shippingAddress}</p>
                <p className="value-info" id="lbl-pcrefresh-delivery_address">{!!variableInfo?.delivery_address? variableInfo?.delivery_address: NOT_APPLICABLE}</p>
            </Grid>
            <Grid item xs={6} className="pr-20">
                <p className="ttl-col-desc">{locale?.trackingInfo}</p>
                <p className="value-info" id="lbl-pcrefresh-trackinginfo">{configTracking(variableInfo?.delivery_ref)}</p>
            </Grid>
        </Grid>
    );
};

export default PCRefreshDetail;